import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
function MethodsOfContact(_ref) {
  var contactMethods = _ref.contactMethods,
    enums = _ref.enums;
  var contactEnums = _.get(enums, 'contact_data.communication_preferences.methods_of_contact', []);
  return /*#__PURE__*/React.createElement("div", {
    className: "methods-of-contact"
  }, _mapInstanceProperty(_).call(_, _filterInstanceProperty(_).call(_, contactEnums, function (method) {
    return _includesInstanceProperty(_).call(_, contactMethods, method.value);
  }), 'display_name').join(', '));
}
MethodsOfContact.propTypes = {
  contactMethods: PropTypes.array.isRequired,
  enums: PropTypes.shape({
    contact_data: PropTypes.shape({
      communication_preferences: PropTypes.shape({
        methods_of_contact: PropTypes.array.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};
export default MethodsOfContact;
//# sourceMappingURL=MethodsOfContact.js.map